import { createAction } from 'redux-actions';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import { FAVORITES } from '../constants/actionTypes';
import API from '../constants/api';

/* Common action creators */

const L = {
  ru: {
    'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.':
      'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.',
    'Чтобы добавлять объявления в избранное, выполните вход.':
      'Чтобы добавлять объявления в избранное, выполните вход.',
  },
  uk: {
    'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.':
      'Вибачте, сталася помилка на сервері, спробуйте повторити операцію пізніше.',
    'Чтобы добавлять объявления в избранное, выполните вход.':
      'Щоб додавати оголошення в обране, виконайте вхід.',
  },
};

const setFavorites = createAction(FAVORITES.SET);
const addToFavorites = createAction(FAVORITES.ADD);
const removeFromFavorites = createAction(FAVORITES.REMOVE);
/* Fetch functions */

const requestAddToFavorites = (fetch, id, token, locale = 'ru') =>
  fetch(API.ADVERT.FAVORITES, {
    method: 'POST',
    headers: {
      Authorization: `JWT ${token}`,
    },
    body: JSON.stringify({ adverts: [id] }),
  }).then(response => {
    if (!response.ok) {
      throw new Error(
        L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.'],
      );
    }
    return response.json();
  });

const requestDeleteFromFavorites = (fetch, id, token, locale = 'ru') =>
  fetch(API.ADVERT.FAVORITES, {
    method: 'DELETE',
    headers: { Authorization: `JWT ${token}` },
    body: JSON.stringify({ adverts: [id] }),
  }).then(response => {
    if (!response.ok) {
      throw new Error(
        L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.'],
      );
    }
    return response.json();
  });

/* Thunks */

let isFetching = false;
let fetchingPromise = null;

export const fetchFavorites = () => (dispatch, getState, { fetch }) => {
  if (!isFetching) {
    const { token } = getState().user;

    if (token) {
      fetchingPromise = fetch(API.ADVERT.FAVORITES, {
        headers: { Authorization: `JWT ${token}` },
      })
        .then(r => r.json())
        .then(r => r && r.adverts)
        .then(favorites => favorites && dispatch(setFavorites(favorites)))
        .then(
          r => {
            isFetching = false;
            return r;
          },
          r => {
            isFetching = false;
            return r;
          },
        );

      isFetching = true;
      return fetchingPromise;
    }

    return Promise.resolve(null);
  }

  return fetchingPromise;
};

export const toggleFavorite = id => (dispatch, getState, { fetch }) => {
  const state = getState();
  const favoritesState = state.favorites;
  const isInFavorites = !!favoritesState && favoritesState.includes(id);
  const { token } = state.user;
  const isUserLoggedIn = !!state.user.token;
  const locale = state.globals.locale;

  if (!isUserLoggedIn) {
    return Promise.reject(
      new Error(L[locale]['Чтобы добавлять объявления в избранное, выполните вход.']),
    );
  }

  if (id) {
    if (isInFavorites) {
      dispatch(removeFromFavorites(id));
      return requestDeleteFromFavorites(fetch, id, token, locale).catch(e => {
        dispatch(addToFavorites(id));
        throw e;
      });
    }

    // Netpeack events
    dispatch(setDataLayer(EVENTS.addToFavorites));
    //
    dispatch(addToFavorites(id));
    return requestAddToFavorites(fetch, id, token, locale).catch(e => {
      dispatch(removeFromFavorites(id));
      throw e;
    });
  }

  return Promise.reject(
    new Error(
      L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.'],
    ),
  );
};



// WEBPACK FOOTER //
// ./src/shared/actions/favorites.js